import { JSX, ReactNode, useId } from "react";
import { QesIcon } from "@app/shared/icons/QESIcon";
import { QesIcons } from "@app/shared/icons/qesIcons";
import NewActionMenu from "@app/shared/action-menu/NewActionMenu";

interface WidgetMenuProps {
  children?: ReactNode;
}

const WidgetMenu = (props: WidgetMenuProps): JSX.Element => {  
  const uniqueId = useId();

  return (
    <NewActionMenu
      alignRight={false}
      buttonClassNames="p-0 text-dark btn-icon btn-sm ni-menu-button"
      containerClassnames="ni-menu-container"
      buttonText={<QesIcon iconName={QesIcons.DotsVertical} description="open menu" />}
      fixMenu={true}
      fixedMenuOffset={{
        x: 0,
        y: -15
      }}
      testId={uniqueId + "_button"}
      key={`${uniqueId}-button`}
      closeOnClick={true}
    >
      <div className="ni-menu-content ni-menu-content__open" id={uniqueId + "_content"}>
          {props.children}
      </div>
    </NewActionMenu>
  );
};

export { WidgetMenu };